import { StarRating } from "~/common/charity/StarRating";

export const FundItemCardFooter = ({
  rating,
  starRating,
  donationWeight,
}: {
  rating?: number;
  starRating: number;
  donationWeight: number;
}) => {
  return (
    <div>
      <div className="tw:flex tw:justify-between tw:items-center tw:leading-none">
        <div className="tw:text-[1.25rem]">
          Score: <strong>{rating ? `${rating}%` : "N/A"}</strong>
        </div>
        <div className="tw:text-[#677093] tw:text-[.75rem] ">% OF FUND</div>
      </div>
      <div className="tw:flex tw:justify-between tw:items-center">
        <StarRating
          rating={starRating ? Number(starRating) : 0}
          width={150}
          height={0}
        />
        <div className="tw:text-[3rem] tw:font-bold tw:leading-none">
          {donationWeight}%
        </div>
      </div>
    </div>
  );
};
